import { Component, OnInit } from '@angular/core';
import { LoaderService } from '@shared/services/loader.service';

@Component({
    selector: 'app-loader-page',
    templateUrl: './loader-page.component.html',
    styleUrls: ['./loader-page.component.css'],
    standalone: false
})
export class LoaderPageComponent implements OnInit {
  constructor(public _loaderService: LoaderService) {}

  ngOnInit(): void {}
}
